import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

export const gestaoCicloRoutes: Routes = [
  {
    path: 'gestao-ciclo',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    data: {
      title: 'Gestão de Ciclo',
      breadcrump: [{ label: 'Gestão de Ciclo', url: '/gestao-ciclo' }],
    },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./gestao-ciclo-list/gestao-ciclo-list.component').then(
            (m) => m.GestaoCicloListComponent,
          ),
        data: {
          title: 'Gestão de Ciclo',
          roles: [Role.GESTAO_CICLO_CONSULTAR],
          breadcrump: [{ label: 'Gestão de Ciclo', url: '/gestao-ciclo' }],
        },
      },
      {
        path: ':cicloId',
        loadComponent: () =>
          import('./gestao-ciclo-detail/gestao-ciclo-detail.component').then(
            (m) => m.GestaoCicloDetailComponent,
          ),
        data: {
          title: 'Detalhes do Ciclo',
          roles: [Role.GESTAO_CICLO_CONSULTAR],
          breadcrump: [
            { label: 'Gestão de Ciclo', url: '/gestao-ciclo' },
            { label: 'Detalhes' },
          ],
        },
      },
    ],
  },
];
